import React, { useEffect, useState } from 'react';
import { 
    Button, Card, CardContent, CardHeader,
    Grid, Cell
} from '@forge/common'
import LineChart from '../components/LineChart/LineChart'
import ValueItem from '../components/ValueItem/ValueItem'
import { Link } from 'react-router-dom';

interface HeaderProps {
    // Aquí puedes definir las props que el componente puede recibir, si las hay
}

const Index: React.FC<HeaderProps> = (args) => {

    const [components, setComponents] = useState([]);

    const baseUrl = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        setComponents([]);
        fetch(`${baseUrl}config/menu.json`)
          .then(response => response.json())
          .then((data: any) => {
            setComponents(data.items);
          })
          .catch(error => console.error("Error loading config:", error));
    }, []);


    const allComponents = components.flat();
    console.log(allComponents, "components")
    const items = [
        { icon: '📄', label: 'Opción 1' },
        { icon: '📊', label: 'Opción 2' },
        { icon: '⚙️', label: 'Configuración' },
        { icon: '🔒', label: 'Cerrar sesión' },
        { icon: '📄', label: 'Opción 1' },
        { icon: '📊', label: 'Opción 2' },
        { icon: '⚙️', label: 'Configuración' },
        { icon: '🔒', label: 'Cerrar sesión' },
        { icon: '📄', label: 'Opción 1' },
        { icon: '📊', label: 'Opción 2' },
        { icon: '⚙️', label: 'Configuración' },
        { icon: '🔒', label: 'Cerrar sesión' }
    ];
    

    return (

        <div>
            <div className="grid grid-cols-12 gap-4 block md:hidden">
                <div className="col-span-12">
                    <h2 className="text-lg font-bold text-center text-gray-800 mt-5 mb-5">HSE - Proyecto Instrumentación DET</h2>
                </div>
            </div>

            <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
        
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12">
                        <h2 className="text-2xl font-bold mb-4 text-center text-gray-800">Instructivos y Documentación HSE</h2>
                    </div>
                    <div className="col-span-12">
                        
                        <div className="w-full max-w-2xl bg-white shadow-lg rounded-2xl p-6 mt-1 mb-3 md:mb-1">
                            <ul className="space-y-3">
                               {allComponents.length > 0 ? (
                                allComponents.map((item: any, index: number) => {
                                    // const isValidLink =
                                    // (item.link.includes("/img/") || item.link.includes("/pdf/")) &&
                                    // (item.link.endsWith(".pdf") || item.link.endsWith(".jpeg"));
                                    
                                    // if (!isValidLink) return null; // Si no cumple, no renderiza nada

                                    return (
                                    <a
                                        href={`${item.link}`}
                                        target="_blank"
                                        key={index}
                                        className="breack-words whitespace-normal flex items-center gap-3 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg p-4 transition"
                                    >
                                        <span className="text-xl">{item.icono}</span>
                                        <span className="text-gray-700 font-medium">{item.titulo}</span>
                                    </a>
                                    );
                                })
                                ) : (
                                <li className="text-gray-500 text-center">Cargando componentes...</li>
                                )}

                            </ul>
                        </div>

                    </div>
                </div>
                

            </div>

        </div>

    

    )

}

export default Index;